import Vue from "vue";
import $axios from "@widget/plugins/axios";

const DEFAULT_COUNT_MIN = 100;
const DEFAULT_COUNT_MAX = 1000000;
const DEFAULT_CREDIT_OBJ = {
    amount: 0,
    chunk: 0,
    method: "not_split",
    description: ""
};

const calculateLeads = {
    namespaced: true,
    state: () => ({
        loading: true,
        count: {
            total: 0,
            min: DEFAULT_COUNT_MIN,
            max: DEFAULT_COUNT_MAX
        },
        quantity: DEFAULT_COUNT_MIN,
        price: 0,
        credit: DEFAULT_CREDIT_OBJ,
        monetaryBudget:0
    }),
    mutations: {
        setLoading (state, payload) {
            state.loading = payload;
        },
        setQuantity (state, payload) {
            state.quantity = payload;
        },
        setPrice (state, payload) {
            state.price = payload;
        },
        setCredit (state, payload) {
            Vue.set(state.credit, payload.key, payload.value);
        },
        setCount (state, payload) {
            Vue.set(state.count, payload.key, payload.value);
        },
        clearCredit (state) {
            state.credit = { ...DEFAULT_CREDIT_OBJ };
        },
        setMonetaryBudget(state,payload) {
            state.monetaryBudget =payload;
        }
    },
    getters: {
        getLoading: state => {
            return state.loading;
        },
        getCount: state => {
            return state.count;
        },
        getQuantity: state => {
            return state.quantity;
        },
        getPrice: state => {
            return state.price;
        },
        getCredit: state => {
            return state.credit;
        },
        getPaymentWay: state => {
            return state.credit.method;
        },
        getMonetaryBudget: state => {
            return state.monetaryBudget;
        }
    },
    actions: {
        getPrice ({ state, commit, rootGetters }) {
            let url = "/api/count/cost";
            let paramsString = window.location.search.substr(1);
            if (paramsString) {
                url += `?${paramsString}`;
            }

            return $axios.post(url, {
                ...rootGetters["widgetData/getQueryForAPI"],
                quantity: state.quantity
            }).then(({ data: { data: response } }) => {
                commit("setPrice", Number(response.total));
                if (response.morePayments && response.morePayments.payments !== 0) {
                    commit("setCredit", {
                        key: "amount",
                        value: Number(response.morePayments.amount)
                    });
                    commit("setCredit", {
                        key: "chunk",
                        value: Number(response.morePayments.payments) + 1
                    });
                    commit("setCredit", {
                        key: "description",
                        value: response.morePayments.description
                    });
                } else {
                    commit("clearCredit");
                }
            });
        },
        getQuantity ({ state, commit, rootGetters }) {
            let url = "/api/count/quantity";
            let paramsString = window.location.search.substr(1);
            if (paramsString) {
                url += `?${paramsString}`;
            }

            return $axios.post(url, {
                ...rootGetters["widgetData/getQueryForAPI"],
                price: state.price
            }).then(({ data: { data: response } }) => {
                commit("setQuantity", Number(response.quantity));
                commit("setPrice", Number(response.total));
                if (response.morePayments && response.morePayments.payments !== 0) {
                    commit("setCredit", {
                        key: "amount",
                        value: Number(response.morePayments.amount)
                    });
                    commit("setCredit", {
                        key: "chunk",
                        value: Number(response.morePayments.payments) + 1
                    });
                    commit("setCredit", {
                        key: "description",
                        value: response.morePayments.description
                    });
                } else {
                    commit("clearCredit");
                }
            });
        },
        getCount ({ state, commit, rootGetters }) {
            return $axios.post("/api/count", rootGetters["widgetData/getQueryForAPI"],{timeout: 120000}).then(({ data: { data: response } }) => {
                commit("setCount", {
                    key: "total",
                    value: Number(response.count)
                });

                if (DEFAULT_COUNT_MAX >= Number(response.count)) {
                    commit("setCount", {
                        key: "max",
                        value: Number(response.count)
                    });

                    commit("setQuantity", Number(response.count));
                } else {
                    commit("setCount", {
                        key: "max",
                        value: DEFAULT_COUNT_MAX
                    });

                    commit("setQuantity", DEFAULT_COUNT_MIN);
                }
            });
        },
        getMonetaryBudget ({ state, commit, rootGetters }) {
            let url = "/api/widget/setting";
            if(Vue.prototype.$widgetUI=='NEW-UI'){
                url +='?type=monetary-budget-new'
            }else{
                url +='?type=monetary-budget'
            }
            return $axios.get(url, {
                ...rootGetters["widgetData/getQueryForAPI"]
            }).then(({ data: { data: response } }) => {
                commit("setMonetaryBudget",response.is_active);
            });
        }
    }
};

export default calculateLeads;
